export default "__VITE_ASSET__BVwXRFCj__"